import { useEffect, useMemo, useState, useCallback, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { APIMS } from "../../../../../config/apims";
import { APILA } from "../../../../../config/apila";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faListUl,
  faCalendarDays,
  faChevronLeft,
  faChevronRight,
  faClock,
  faCalendar
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";

/** react-big-calendar (moment localizer) */
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import "moment/locale/id";

/** Modal Add/Edit */
import ModalEvent from "./modal/add";

/** API Academic Calendar (MS) */
const API_CREATE = "/api/academic-calendars/store";
const API_UPDATE = (id) => `/api/academic-calendars/${id}`;
const API_DELETE = (id) => `/api/academic-calendars/${id}`;

moment.locale("id");
const localizer = momentLocalizer(moment);

const calendarPageStyles = `
  .calendar-filter-card {
    width: 100%;
    margin-bottom: 18px;
    padding: 18px;
    border: 1px solid #e5eaf4;
    border-radius: 16px;
    background: #ffffff;
  }

  .calendar-filter-grid {
    display: grid;
    // grid-template-columns: repeat(3, minmax(190px, 1fr)) auto;
     grid-template-columns:
      minmax(190px, 0.9fr)
      minmax(240px, 1.2fr)
      minmax(190px, 0.9fr)
      auto;
    align-items: end;
    gap: 14px;
  }

  .calendar-filter-field {
    min-width: 0;
  }

  .calendar-filter-button {
    display: inline-flex;
    min-width: 108px;
    height: 44px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 0 18px;
    border: 0;
    border-radius: 10px;
    // background: #3f5bea;
    background: #f4aa33;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 7px 16px rgba(63, 91, 234, 0.18);
    transition: transform 0.2s ease, opacity 0.2s ease;
  }

  .calendar-filter-button:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  .calendar-filter-button:disabled {
    cursor: not-allowed;
    background: #c9cfdd;
    box-shadow: none;
  }

  .calendar-filter-skeleton-group {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 8px;
  }

  .calendar-filter-shimmer {
    position: relative;
    overflow: hidden;
    // background: #edf1f7;
     background: linear-gradient(
      to right,
      #ddeaff 8%,
      #f4f8ff 18%,
      #ddeaff 33%
    );
  }

  .calendar-filter-shimmer::after {
    position: absolute;
    inset: 0;
    content: "";
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.72) 50%,
      transparent 100%
    );
    animation: calendar-filter-shimmer 1.25s ease-in-out infinite;
  }

  .calendar-filter-skeleton-label {
    width: 92px;
    height: 13px;
    border-radius: 6px;
  }

  .calendar-filter-skeleton-control {
    width: 100%;
    height: 44px;
    border-radius: 10px;
  }

  .calendar-filter-skeleton-button {
    width: 108px;
    height: 44px;
    border-radius: 10px;
  }

  @keyframes calendar-filter-shimmer {
    100% {
      transform: translateX(100%);
    }
  }

  @media (max-width: 980px) {
    .calendar-filter-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .calendar-filter-button {
      width: 100%;
    }
  }

  @media (max-width: 640px) {
    .calendar-filter-card {
      padding: 15px;
      border-radius: 13px;
    }

    .calendar-filter-grid {
      grid-template-columns: 1fr;
      gap: 13px;
    }
  }
`;

/** ================= CUSTOM TOOLBAR ================= */
function CustomToolbar(toolbar) {
  const goToBack = () => toolbar.onNavigate("PREV");
  const goToNext = () => toolbar.onNavigate("NEXT");
  const goToToday = () => toolbar.onNavigate("TODAY");
  const changeView = (view) => toolbar.onView(view);

  const viewButtonStyle = (isActive) => ({
    border: "none",
    outline: "none",
    padding: "9px 16px",
    borderRadius: 12,
    fontSize: 13,
    fontWeight: 700,
    cursor: "pointer",
    transition: "all 0.2s ease",
    background: isActive
      ? "linear-gradient(135deg, #3f5bea 0%, #0c00ef 500%)"
      : "#e8f2ff",
    color: isActive ? "#fff" : "#436cd4",
    boxShadow: isActive ? "0 10px 20px rgba(108, 99, 255, 0.20)" : "none",
  });

  const navButtonStyle = {
    width: 38,
    height: 38,
    borderRadius: "50%",
    border: "1px solid #ece8ff",
    background: "#fff",
    color: "#436cd4",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 12px rgba(76, 68, 182, 0.08)",
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 14,
        marginBottom: 18,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <button type="button" onClick={() => changeView("month")} style={viewButtonStyle(toolbar.view === "month")}>
          Bulan
        </button>
        <button type="button" onClick={() => changeView("week")} style={viewButtonStyle(toolbar.view === "week")}>
          Minggu
        </button>
        <button type="button" onClick={() => changeView("agenda")} style={viewButtonStyle(toolbar.view === "agenda")}>
          Agenda
        </button>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          flexWrap: "wrap",
          marginLeft: "auto",
        }}
      >
        <button
          type="button"
          onClick={goToToday}
          style={{
            border: "1px solid #ece8ff",
            background: "#fff",
            color: "#436cd4",
            borderRadius: 12,
            padding: "8px 14px",
            fontSize: 13,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Hari ini
        </button>

        <span
          style={{
            fontSize: 18,
            fontWeight: 800,
            color: "#2a3b90",
            minWidth: 180,
            textAlign: "center",
          }}
        >
          {toolbar.label}
        </span>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button type="button" onClick={goToBack} style={navButtonStyle}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <button type="button" onClick={goToNext} style={navButtonStyle}>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    </div>
  );
}

/** ================= CUSTOM EVENT ================= */
function EventCard({ event }) {
  return (
    <div
      title={event.title}
      style={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        fontSize: 11,
        fontWeight: 700,
        padding: "2px 4px",
      }}
    >
      {event.title}
    </div>
  );
}

export default function Kalender() {
  
  document.title = "Kalender Akademik";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

    /** list request */
  const [search] = useState("");
  const [level] = useState("");


  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);
  const initKelasDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);

// UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  

  const API_LIST = `/api/academic-calendars?page=1&limit=1000&ascending=${ascending}&search=`;

  /** FILTER */
  const [filter, setFilter] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
  });

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
  });


  /** DATA EVENT */
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);

  /** Modal */
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // add | edit
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [prefillDate, setPrefillDate] = useState(null);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  // SORT sekolah: SD → SMP → SMA
  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];
    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
      const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
    return schools;
  };

  // =========================
  // INIT: Branch + Semester 
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [branchRes, semesterRes] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          { ...fetchParams, signal: controller.signal }
        ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      // Branch default pertama
      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];
        setGetDataBranch(branches);
        if (branches.length > 0) {
          const firstBranch = branches[0].branch_code;
          setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
        }
      }

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } 

  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  // =========================
  // Fetch sekolah saat branch berubah
  // =========================
  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      initSchoolDone.current = false;
      initLevelDone.current = false;
      initKelasDone.current = false;
      setLoadingSchool(true); // ⬅️ school mulai load
      try {
        const res = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );
        if (res?.status === 200) {
          let schools = res.data.data || [];

          // ✅ FILTER ULANG UNTUK ROLE DEVELOPER
          if (storageLevel === "developer" || storageLevel === "superadmin") {
            schools = schools.filter(
              (s) => s.ysb_branch_id === branchId
            );
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          // default sekolah pertama
          if (schools.length > 0) {
            // reset dependensi saat sekolah berubah (tingkatan/kelas/guru)
            // setGetDataLevel([]);
            setForm2((prev) => ({
              ...prev,
              ysb_school_id: schools[0].school_code,
              ysb_kelas_id: "",
              ysb_teacher_id: "",
            }));
          } else {
            // setGetDataLevel([]);
            setForm2((prev) => ({ ...prev, ysb_school_id: "", }));
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
          initSchoolDone.current = true;
          setLoadingSchool(false); // ⬅️ school SELESAI
          setLoading(false);       // ⬅️ shimmer BARU MATI DI SINI
      }
    },[ascending, fetchParams, limit, page, storageLevel]
  );

  useEffect(() => {
    if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
  }, [form2.ysb_branch_id, fetchSchoolsByBranch]);


  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      loadingSchool
    ) {
      return;
    }

    setFilter({
      ysb_semester_id: form2.ysb_semester_id,
      ysb_branch_id: form2.ysb_branch_id,
      ysb_school_id: form2.ysb_school_id,
    });

    firstLoadDone.current = true;
    setIsFirstLoad(false);
    setHasSearched(true);
    setIsFilterDirty(false);
  }, [form2, loadingSchool]);


  // =========================
  // HANDLER perubahan filter (select HTML)
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => {
      const next = { ...prev, [name]: value };

      if (name === "ysb_branch_id") {
        next.ysb_school_id = "";
      }

      return next;
    });

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };


  /** ================= FETCH ================= */
  const GetResponseData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await APIMS.get(
        `${API_LIST}&semester=${filter?.ysb_semester_id || ""}&branch=${filter?.ysb_branch_id || ""}&school=${filter?.ysb_school_id || ""}&level=${storageLevel || level || ""}`,
        fetchParams
      );

      setAllData(response.data?.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data kalender",
      });
    }
  }, [API_LIST, fetchParams, filter?.ysb_branch_id, filter?.ysb_school_id, filter?.ysb_semester_id, level, storageLevel]);

  useEffect(() => {
    if (!filter.ysb_semester_id || !filter.ysb_branch_id || !filter.ysb_school_id) return;
    GetResponseData();
  }, [GetResponseData, filter]);

  /** ================= NORMALIZER ================= */
  const normalizeToRBCEvent = (item, index) => {
    const id = item?.id;
    const title = item?.title || "-";

    const startStr = item?.date_in ? String(item.date_in).slice(0, 10) : null;
    const endStr = item?.date_out ? String(item.date_out).slice(0, 10) : startStr;

    if (!startStr) return null;

    const startDate = new Date(`${startStr}T00:00:00`);
    const endDate = new Date(`${endStr}T00:00:00`);

    const endPlusOne = new Date(endDate);
    endPlusOne.setDate(endPlusOne.getDate() + 1);

    const palette = [
      {
        bg: "linear-gradient(135deg, rgba(144, 224, 239, 0.35), rgba(202, 240, 248, 0.75))",
        border: "#7bdff2",
        color: "#1c6b82",
      },
      {
        bg: "linear-gradient(135deg, rgba(255, 214, 165, 0.38), rgba(255, 239, 213, 0.85))",
        border: "#ffbe7b",
        color: "#9f5f00",
      },
      {
        bg: "linear-gradient(135deg, rgba(205, 180, 219, 0.35), rgba(245, 239, 255, 0.85))",
        border: "#c8a2ff",
        color: "#6b4ca5",
      },
      {
        bg: "linear-gradient(135deg, rgba(186, 230, 253, 0.35), rgba(224, 242, 254, 0.9))",
        border: "#7dd3fc",
        color: "#0369a1",
      },
      {
        bg: "linear-gradient(135deg, rgba(253, 230, 138, 0.34), rgba(254, 249, 195, 0.9))",
        border: "#facc15",
        color: "#a16207",
      },
    ];

    const selectedPalette = palette[index % palette.length];

    return {
      id: String(id),
      title,
      start: startDate,
      end: endPlusOne,
      allDay: true,
      raw: item,
      eventStyle: selectedPalette,
    };
  };

  const calendarEvents = useMemo(() => {
    return (allData || []).map((item, index) => normalizeToRBCEvent(item, index)).filter(Boolean);
  }, [allData]);

  /** ================= UPCOMING EVENTS ================= */
  const upcomingEvents = useMemo(() => {
    const today = moment().startOf("day");

    return [...calendarEvents]
      .filter((item) => moment(item.start).isSameOrAfter(today))
      .sort((a, b) => new Date(a.start) - new Date(b.start))
      .slice(0, 5);
  }, [calendarEvents]);

  /** ================= DELETE ================= */
  const deleteById = (id) => {
    Swal.fire({
      title: "Apakah Kamu Yakin?",
      text: "Data yang dihapus tidak bisa dikembalikan",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          const response = await APIMS.delete(API_DELETE(id), fetchParams);
          if (response.data?.error) throw new Error(response.data?.message);
          return response;
        } catch (error) {
          Swal.showValidationMessage(
            error.response?.data?.message || error.message || "Gagal menghapus data"
          );
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        ToastSuccess.fire({ icon: "success", title: "Event berhasil dihapus" });
        GetResponseData();
      }
    });
  };

  /** ================= CLICK TANGGAL => ADD ================= */
  const handleSelectSlot = (slotInfo) => {
    const d = slotInfo?.start ? moment(slotInfo.start).format("YYYY-MM-DD") : null;

    setPrefillDate(d);
    setSelectedEvent(null);
    setModalMode("add");
    setModalOpen(true);
  };

  /** ================= CLICK EVENT => EDIT ================= */
  const handleSelectEvent = (event) => {
    setSelectedEvent(event?.raw || null);
    setPrefillDate(null);
    setModalMode("edit");
    setModalOpen(true);
  };

  /** ================= FILTER HANDLER ================= */
  const handleSearchClick = () => {
    setFilter({
      ysb_semester_id: form2.ysb_semester_id || "",
      ysb_branch_id: form2.ysb_branch_id || "",
      ysb_school_id: form2.ysb_school_id || "",
    });
    setHasSearched(true);
    setIsFilterDirty(false);
  };

  /** ================= CALENDAR STYLE ================= */
  const eventPropGetter = (event) => {
    const custom = event?.eventStyle || {};

    return {
      style: {
        background: custom.bg || "linear-gradient(135deg, #e9e4ff, #f5f1ff)",
        border: `1px solid ${custom.border || "#c8a2ff"}`,
        color: custom.color || "#5b4b8a",
        borderRadius: 10,
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        padding: "2px 4px",
        fontWeight: 700,
      },
    };
  };

  const dayPropGetter = (date) => {
    const isToday = moment(date).isSame(moment(), "day");
    return {
      style: {
        backgroundColor: isToday ? "#faf8ff" : "#fff",
      },
    };
  };

  const containerStyle = {
    background: "linear-gradient(135deg, #f7f8ff 0%, #eef4ff 45%, #f9fbff 100%)",
    borderRadius: 24,
    padding: isTabletOrMobile ? 14 : 22,
    border: "1px solid #edf0ff",
    boxShadow: "0 20px 60px rgba(71, 85, 164, 0.10)",
  };

  return (
    <div className="body module-page">
      <style>{calendarPageStyles}</style>

      {modalOpen && (
        <ModalEvent
          show={modalOpen}
          onHide={() => setModalOpen(false)}
          mode={modalMode}
          initialData={selectedEvent}
          prefillDate={prefillDate}
          apiCreate={API_CREATE}
          apiUpdate={API_UPDATE}
          apiDelete={API_DELETE}
          GetResponseData={GetResponseData}
          filterContext={filter}
          onDeleted={(id) => deleteById(id)}
        />
      )}

      

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          {isTabletOrMobile ? (
            <>
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faCalendarDays} />
                </span>
                <h4 className="page-title-text"> Data Kalender Akademik</h4>
              </div>

              <div className="ml-auto">
                <button
                  onClick={() => {
                    setModalMode("add");
                    setSelectedEvent(null);
                    setPrefillDate(null);
                    setModalOpen(true);
                  }}
                  className="btn btn-create"
                >
                  <FontAwesomeIcon icon={faPlus} /> Kalender Akademik
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faCalendarDays} />
                </span>
                <h4 className="page-title-text"> Data  Kalender Akademik</h4>
              </div>

              <div className="ml-auto"> 
                <button
                  onClick={() => {
                    setModalMode("add");
                    setSelectedEvent(null);
                    setPrefillDate(null);
                    setModalOpen(true);
                  }}
                  className="btn btn-create "
                  style={{
                    borderRadius: 12,
                    padding: "8px 14px",
                    boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                  }}
                >
                  <FontAwesomeIcon icon={faCalendar} /> Buat Jadwal Acara
                </button>

                {/* <button
                  className="btn btn-create"
                  style={{
                    backgroundColor: "#00a6ff",
                    borderRadius: 12,
                    padding: "8px 14px",
                    boxShadow: "0 10px 24px rgba(0,166,255,0.16)",
                  }}
                >
                  <Link to="/events" style={{ textDecoration: "none", color: "#fff" }}>
                    <FontAwesomeIcon icon={faPlus} /> Buat Tipe Acara
                  </Link>
                </button> */}
            
                  <button
                   className="btn "
                   >
                    <Link to="/kalender-akademik/events" className="menu-navigation-button">
                      <FontAwesomeIcon /> Tipe Acara
                    </Link>
                  </button>
                 
              </div>
            </>
          )}
        </div>
      </div>

      <div className="body-content module-content">
        <div className="calendar-filter-card">
          {loading ? (
            <div className="calendar-filter-grid" aria-label="Memuat filter">
              {["semester", "branch", "school"].map((item) => (
                <div className="calendar-filter-skeleton-group" key={item}>
                  <div className="calendar-filter-shimmer calendar-filter-skeleton-control" />
                </div>
              ))}

              <div className="calendar-filter-shimmer calendar-filter-skeleton-button" />
            </div>
          ) : (
            <div className="calendar-filter-grid">
              <div className="calendar-filter-field">
                <label className="module-form-label" htmlFor="calendar-semester-filter">
                  Tahun Ajaran
                </label>
                <select
                  id="calendar-semester-filter"
                  className="module-form-select"
                  name="ysb_semester_id"
                  value={form2.ysb_semester_id}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    {namaTA && namaSmstr
                      ? `${namaTA} (Semester ${namaSmstr})`
                      : "Pilih Tahun Ajaran"}
                  </option>
                  {getDataSemesterMap.map((semester) => (
                    <option key={semester?.id} value={semester?.id}>
                      {semester?.name_year} (Semester {semester?.semester})
                    </option>
                  ))}
                </select>
              </div>

              <div className="calendar-filter-field">
                <label className="module-form-label" htmlFor="calendar-branch-filter">
                  Cabang
                </label>
                <select
                  id="calendar-branch-filter"
                  className="module-form-select"
                  name="ysb_branch_id"
                  value={form2.ysb_branch_id}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Pilih Cabang
                  </option>
                  {getDataBranch.map((branch) => (
                    <option key={branch?.branch_code} value={branch?.branch_code}>
                      {branch?.branch_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="calendar-filter-field">
                <label className="module-form-label" htmlFor="calendar-school-filter">
                  Sekolah
                </label>
                <select
                  id="calendar-school-filter"
                  className="module-form-select"
                  name="ysb_school_id"
                  value={form2.ysb_school_id}
                  onChange={handleChange}
                  disabled={!form2.ysb_branch_id || loadingSchool}
                >
                  <option value="" disabled>
                    {!form2.ysb_branch_id
                      ? "Pilih Cabang terlebih dahulu"
                      : loadingSchool
                      ? "Memuat data sekolah..."
                      : "Pilih Sekolah"}
                  </option>
                  {!loadingSchool &&
                    getDataSchool.map((school) => (
                      <option key={school?.school_code} value={school?.school_code}>
                        {school?.school_name}
                      </option>
                    ))}
                </select>
              </div>

              <button
                type="button"
                className="calendar-filter-button"
                onClick={handleSearchClick}
                disabled={
                  loadingSchool ||
                  !form2.ysb_semester_id ||
                  !form2.ysb_branch_id ||
                  !form2.ysb_school_id
                }
              >
                Tampilkan Data
              </button>
            </div>
          )}
        </div>

        {/* KALENDER  */}
        <div style={containerStyle}>
          {loading ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                gap: 12,
                padding: 40,
                minHeight: 320,
                background: "#fff",
                borderRadius: 20,
              }}
            >
              <PulseLoader size={10} />
              <span style={{ fontSize: 14, color: "#666" }}>Memuat event...</span>
            </div>
          ) : (
            <>
              <style>
                {`
                  .beautiful-calendar-layout {
                    // display: grid;
                    // grid-template-columns: ${isTabletOrMobile ? "1fr" : "320px 1fr"};
                    // gap: 20px;
                    // align-items: start;
                  }

                  .beautiful-calendar-sidebar {
                    background: linear-gradient(180deg, #eef5ff 0%, #f7fbff 100%);
                    border-radius: 24px;
                    padding: 22px 18px;
                    min-height: ${isTabletOrMobile ? "auto" : "780px"};
                    border: 1px solid #e7efff;
                    box-shadow: inset 0 1px 0 rgba(255,255,255,0.7);
                  }

                  .beautiful-calendar-main {
                    background: #ffffff;
                    border-radius: 24px;
                    padding: 20px;
                    border: 1px solid #eef1ff;
                    box-shadow: 0 10px 30px rgba(99, 102, 241, 0.06);
                    overflow: hidden;
                  }

                  .rbc-calendar {
                    font-family: inherit;
                  }

                  .rbc-toolbar {
                    display: none !important;
                  }

                  .rbc-month-view,
                  .rbc-time-view,
                  .rbc-agenda-view {
                    border: 1px solid #f0effa !important;
                    border-radius: 18px;
                    overflow: hidden;
                    background: #fff;
                  }

                  .rbc-header {
                    background: #e8f2ff;
                    color: #436cd4;
                    font-weight: 700;
                    font-size: 13px;
                    padding: 14px 6px !important;
                    border-bottom: 1px solid #ebe8fb !important;
                  }

                  .rbc-month-row {
                    min-height: ${isTabletOrMobile ? "90px" : "112px"};
                  }

                  .rbc-date-cell {
                    padding: 8px 10px 0 0 !important;
                    text-align: right;
                    font-size: 12px;
                    font-weight: 700;
                    color: #666;
                  }

                  .rbc-date-cell > a {
                    color: #666 !important;
                    text-decoration: none !important;
                  }

                  .rbc-off-range-bg {
                    background: #fbfbfe !important;
                  }

                  .rbc-off-range {
                    color: #b7b7c9 !important;
                  }

                  .rbc-today {
                    background-color: #ebf6ff !important;
                  }

                  .rbc-day-bg + .rbc-day-bg,
                  .rbc-month-row + .rbc-month-row,
                  .rbc-header + .rbc-header {
                    border-left: 1px solid #f2f2fa !important;
                  }

                  .rbc-row-content {
                    z-index: 4 !important;
                  }

                  .rbc-event {
                    min-height: 28px;
                    padding: 2px 6px !important;
                    border: none;
                  }

                  .rbc-event:focus,
                  .rbc-day-slot .rbc-event:focus {
                    outline: none !important;
                  }

                  .rbc-show-more {
                    color: #6c63ff !important;
                    font-weight: 700;
                    background: transparent !important;
                  }

                  .rbc-agenda-view table.rbc-agenda-table {
                    border: none !important;
                  }

                  .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
                    background: #e8f2ff;
                    color: #436cd4;
                    border-bottom: 1px solid #ebe8fb;
                    padding: 12px 10px;
                    font-weight: 700;
                  }

                  .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
                    padding: 12px 10px;
                    border-bottom: 1px solid #f2f2fa;
                  }

                  .rbc-btn-group button {
                    border-radius: 10px !important;
                  }
                `}
              </style>

              <div className="beautiful-calendar-layout">
                

                {/* MAIN CALENDAR */}
                <div className="beautiful-calendar-main">
                  <Calendar
                    localizer={localizer}
                    culture="id"
                    messages={{
                      today: "Hari ini",
                      previous: "<",
                      next: ">",
                      month: "Bulan",
                      week: "Minggu",
                      agenda: "Agenda",
                      date: "Tanggal",
                      time: "Waktu",
                      event: "Event",
                      noEventsInRange: "Tidak ada event pada rentang ini",
                      showMore: (total) => `+${total} lagi`,
                    }}
                    events={calendarEvents}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: isTabletOrMobile ? 620 : 780 }}
                    selectable
                    onSelectSlot={handleSelectSlot}
                    onSelectEvent={handleSelectEvent}
                    views={["month", "week", "agenda"]}
                    popup
                    eventPropGetter={eventPropGetter}
                    dayPropGetter={dayPropGetter}
                    components={{
                      toolbar: CustomToolbar,
                      event: EventCard,
                    }}
                  />

                  <div
                    style={{
                      marginTop: 14,
                      fontSize: 12,
                      color: "#7f86a6",
                      background: "#f8f9ff",
                      border: "1px solid #edf0ff",
                      padding: "12px 14px",
                      borderRadius: 14,
                    }}
                  >
                    Tips: Klik tanggal untuk tambah event, dan klik event untuk edit data.
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}